import React from 'react';
import { Link } from 'react-router-dom';
import { Users, FileText, ArrowRight } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { services } from '../data/mock';
import '../styles/pages.css';
import usePageMeta from '../hooks/usePageMeta';

// Imágenes únicas para cada servicio
const serviceImages = [
  "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?w=600&q=80", // Consultoría estratégica
  "https://images.unsplash.com/photo-1588600878108-578307a3cc9d?w=600&q=80", // Evaluación de riesgos
  "https://images.unsplash.com/photo-1760872703636-f8d643a2b510?w=600&q=80", // Auditoría técnica
  "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&q=80", // Acompañamiento operativo
  "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=600&q=80"  // Capacitación
];

// Imagen única para el header de servicios
const headerImage = "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1920&q=80";

const Services = () => {
  usePageMeta({
    title: 'Servicios',
    description: 'Consultoría, capacitación, operación, movilidad y producción para eventos que requieren el más alto estándar de protección.',
    path: '/services',
  });

  return (
    <Layout>
      {/* Page Header with Background */}
      <section className="page-header page-header-image" style={{backgroundImage: `url(${headerImage})`}}>
        <div className="page-header-overlay"></div>
        <div className="container">
          <h1>Servicios</h1>
          <p>Soluciones integrales de consultoría en seguridad para eventos</p>
        </div>
      </section>

      {/* Services List */}
      <section className="section">
        <div className="container">
          <div className="services-list">
            {services.map((service, index) => (
              <div key={service.id} className={`service-card-enhanced ${index % 2 === 1 ? 'reverse' : ''}`}>
                <div className="service-image">
                  <img src={serviceImages[index]} alt={service.title} />
                </div>
                <div className="service-content-enhanced">
                  <div className="service-number">{String(index + 1).padStart(2, '0')}</div>
                  <h3>{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <div className="service-details-enhanced">
                    <div className="service-detail">
                      <div className="detail-icon">
                        <Users size={18} />
                      </div>
                      <div>
                        <span className="detail-label">Dirigido a</span>
                        <p>{service.forWhom}</p>
                      </div>
                    </div>
                    <div className="service-detail">
                      <div className="detail-icon">
                        <FileText size={18} />
                      </div>
                      <div>
                        <span className="detail-label">Entregable</span>
                        <p>{service.deliverable}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Info */}
      <section className="section section-alt">
        <div className="container">
          <div className="info-box">
            <h3>Servicios personalizados</h3>
            <p>
              Cada evento es único y requiere un enfoque adaptado a sus características 
              específicas. Nuestros servicios se diseñan a la medida de las necesidades 
              de cada cliente, considerando el tipo de evento, la escala, el perfil de 
              asistentes y el contexto particular.
            </p>
            <p>
              Trabajamos en estrecha colaboración con organizadores, productoras y 
              recintos para garantizar que cada solución sea práctica, viable y efectiva.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>¿Qué servicio necesita?</h2>
            <p>
              Contáctenos para una evaluación inicial y le ayudaremos a 
              identificar la solución más adecuada para su evento.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Solicitar información
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Services;
